<template>
  <div class="chest-pg">
    <progress-bar/>

    <span class="form-input-title-label">Your chest shape</span>

    <div class="img-select-form">
      <div class="img-select no-ml" :class="{active: chestShape === -1}">
        <div class="img-container first male" @click="setChestShape(-1)"></div>
        <span class="centered-vertically">Slimmer</span>
      </div>

      <div class="img-select" :class="{active: chestShape === 0}">
        <div class="img-container second male" @click="setChestShape(0)"></div>
        <span class="centered-vertically">Average</span>
      </div>

      <div class="img-select" :class="{active: chestShape === 1}">
        <div class="img-container third male" @click="setChestShape(1)"></div>
        <span class="centered-vertically">Broader</span>
      </div>
    </div>

    <navigation/>
  </div>
</template>

<script>
import ProgressBar from "../../ProgressBar";
import Navigation from "../../Navigation";
import {mapFields} from 'vuex-map-fields';

export default {
  name: "ChestView",

  components: {Navigation, ProgressBar},

  computed: {
    ...mapFields('userSelections', [
      'male.chestShape',
    ]),
  },

  methods: {
    setChestShape(value) {
      this.chestShape = value;
    },
  },
};
</script>
